import React, { useState, useMemo, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CheckIcon from '@mui/icons-material/Check';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { putCEECampaignMembershipCase, downloadFile, postFileUpload } from "services/ConfigServices";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { ceecasefile } from "variables/cee";
import { ceecasefileStatusData } from "variables/lists/cee";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import CEECampaignsContext from "context/CEECampaignsContext";
import useCaseFilesTable from "./useCaseFilesTable.js";
import PublishIcon from "@mui/icons-material/Publish";
import FileUpload from "components/CustomUpload/FileUpload";

//import CaseDialog from "./CaseDialog";
import EditCaseFileStatusDialog from "./EditCaseFileStatusDialog";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementSectionTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  font-family: "Source Sans Pro",sans-serif;
  text-decoration: underline;
  margin-top: 10px;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const ElementDataDownload = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};


const useStyles = makeStyles(styles);


function RTCaseFiles(props) {
  const { casefiles, setCasefiles, groups } = props;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const cee_update = permis.includes("cee_update");
  const cee_admin = permis.includes("cee_admin");
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [openValidateOrder, setOpenValidateOrder] = useState(false);
  const { gridState, refetch, setSelectedElementFiles } = useCaseFilesTable();
  const [currentCaseFile, setCurrentCaseFile] = useState("");
  const [file, setFile] = useState(null);

  let dataCases = [];

  const classes = useStyles();

  const columns = [
    {
      name: ceecasefile.doctype,
      selector: (row) => row.parameters.doctype,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: ceecasefile.docname,
      selector: (row) => row.parameters.docname,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: ceecasefile.associatedfiles,
      selector: row => row.parameters.associatedfiles,
      sortable: true,
      cell: (row) => <ElementDataDownload
        onClick={downloadGED(row.parameters?.associatedfiles.fileId, row.parameters?.associatedfiles.fileName)}> {row.parameters?.associatedfiles.fileName}
      </ElementDataDownload>,
    },
    {
      name: ceecasefile.fillassociatedfiles,
      selector: row => row.parameters.associatedfiles,
      sortable: true,
      cell: (row) => <ElementDataDownload
        onClick={downloadGED(casefiles?.find((o) => o.requiredfileid == row.id)?.fileId, casefiles?.find((o) => o.requiredfileid == row.id)?.fileName)}> {casefiles?.find((o) => o.requiredfileid == row.id)?.fileName}
      </ElementDataDownload>,
    },
    {
      name: ceecasefile.status,
      selector: (row) => row.parameters.status,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => casefiles?.find((o) => o.requiredfileid == row.id) ?
        <div style={{ color: ceecasefileStatusData.find((x) => x.id == casefiles?.find((o) => o.requiredfileid == row.id).status).color, fontWeight: "bold" }}>
          {ceecasefileStatusData.find((x) => x.id == casefiles?.find((o) => o.requiredfileid == row.id).status).name}
        </div> :
        <div style={{ color: ceecasefileStatusData.find((x) => x.id == "nofile").color, fontWeight: "bold" }}>
          {ceecasefileStatusData.find((x) => x.id == "nofile").name}
        </div>
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {
              cee_admin && row.parameters.status !== 'membervalidation' &&
              <Tooltip title="Changer le statut">
                <Button
                  onClick={editCaseFileStatus(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <ExitToAppIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
            {cee_update && (!casefiles?.find((o) => o.requiredfileid == row.id) ||
              casefiles?.find((o) => o.requiredfileid == row.id).status !== 'unwanted') &&
              <FileUpload
                handleFileChange={handleFileChange}
                row={row}
              />
            }
            {/* {cee_update && casefiles?.find((o) => o.requiredfileid == row.id)?.fileId &&
              <Tooltip title="Supprimer le fichier'">
                <CustomDeleteButton
                  deleteTitle={"Suppression du fichier"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le fichier importé?`}
                  handleSupprimer={deleteCaseFunction(row)}
                />
              </Tooltip>
            } */}
          </div>
        </>
      ),
    },
  ];

  const handleClickStatusOpen = () => {
    setOpenStatus(true);
  };
  const handleEditStatusClose = () => {
    setOpenStatus(false);
  };


  const handleFileChange = (row, file) => {
    let newcasefiles = [...casefiles];
    let obj = casefiles?.find((o) => o.requiredfileid == row.id);
    if (!obj) {
      let newcasefile = { status: "nofile", requiredfileid: row.id };
      obj = newcasefile;
      newcasefiles.push(obj);
    }
    if (file && obj) {
      const formData = new FormData();
      formData.append("files", file);
      axios
        .post(postFileUpload(groups, "GED"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          obj.fileId = res.data.files[0].id;
          obj.fileName = res.data.files[0].name;
          obj.status = "pending";
          let index = newcasefiles?.findIndex((o) => o.requiredfileid == obj.requiredfileid);
          newcasefiles.splice(index, 1, obj);
          setCasefiles(newcasefiles);
        })
        .catch(() => { });
    }
  }

  const editCaseFileStatus = (row) => async () => {
    let obj = casefiles?.find((o) => o.requiredfileid == row.id);
    if (!obj) {
      let newcasefile = { status: "nofile", requiredfileid: row.id };
      let newcasefiles = [...casefiles];
      newcasefiles.push(newcasefile);
      setCasefiles(newcasefiles);
      obj = newcasefile;
    }
    if (obj) {
      setCurrentCaseFile(obj);
      handleClickStatusOpen();
    }
  }


  const deleteCaseFunction = (row) => async () => {
    // let obj = dataCases.find((o) => o.id === row.id);
    // let idSelected = obj.id;
    // let url = deleteCEECampaignMembershipCase(idSelected);
    // axios
    //   .delete(url, {
    //     headers: {
    //       Authorization: `Bearer ${UserService.getToken()}`,
    //     },
    //   })
    //   .then((res) => {
    //     if (res.status == 200) {
    //       setNotification(
    //         "success",
    //         `Le dossier a été supprimé`
    //       );
    //       refetch();
    //     } else setNotification("error", "Une erreur est survenue");
    //   })
    //   .catch((error) => {
    //     setNotification("error", "Une erreur est survenue");
    //   });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun fichier à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressComponent={<LinearProgress />}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditStatusClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openStatus}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditStatusClose}>
          Modification du document
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditCaseFileStatusDialog
            currentCaseFile={currentCaseFile}
            casefiles={casefiles}
            setCasefiles={setCasefiles}
            closeModal={handleEditStatusClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTCaseFiles;
